import { Lazyload } from "../cutil/Lazyload";
import { StoreBase } from "../cutil/StoreBase";
export class ToolPieceStore extends StoreBase {
    constructor(brainClient) {
        super(() => []);
        this.brainClient = brainClient;
        this.lazyload = new Lazyload(() => {
            return this.brainClient.openAi.getToolPiecesList().then(result => {
                const state = result.data.toolpieces;
                this.emit(state);
                return state;
            });
        });
    }
    async get() {
        return this.lazyload.get();
    }
    async renew() {
        await this.lazyload.renew();
    }
}
